import { IoMdMedal, IoMdTrophy } from "react-icons/io";

export const Number = (props) => {
  return <span className="fw-bold text-primary fs-4">{props.value}</span>;
};

export const Text = (props) => {
  return <span className="fw-bold text-secondary fs-4">{props.value}</span>;
};

export const Trophy = (props) => {
  switch (props.val) {
    case "MG":
      return (
        <div style={{ color: "gold" }}>
          <IoMdMedal size="25" /> <span className="fw-bold fs-4 align-middle">{props.name}</span>
        </div>
      );
    case "MS":
      return (
        <div style={{ color: "silver" }}>
          <IoMdMedal size="25" /> <span className="fw-bold fs-4 align-middle">{props.name}</span>
        </div>
      );
    case "MB":
      return (
        <div style={{ color: "#CD7F32" }}>
          <IoMdMedal size="25" /> <span className="fw-bold fs-4 align-middle">{props.name}</span>
        </div>
      );
    case "T1":
      return (
        <div style={{ color: "gold" }}>
          <IoMdTrophy size="25" /> <span className="fw-bold fs-4 align-middle">{props.name}</span>
        </div>
      );
    case "T2":
      return (
        <div style={{ color: "silver" }}>
          <IoMdTrophy size="25" /> <span className="fw-bold fs-4 align-middle">{props.name}</span>
        </div>
      );
    default:
      <></>;
  }
};
